// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"343":"ShippingDisclaimerDialog","856":"LazyProductQuickAdd"}[chunkId] || chunkId) + ".chunk.min.css";
};